const IconStarOutline = ({ width = 24, height = 25, fill = "#252525" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M19.1495 9.49694L14.6253 9.11199L12.8586 5.03336C12.5408 4.29096 11.4565 4.29096 11.1387 5.03336L9.37198 9.12115L4.85713 9.49694C4.03455 9.56109 3.69804 10.5693 4.32432 11.1009L7.75486 14.0155L6.72663 18.3416C6.53968 19.1298 7.409 19.7531 8.11941 19.3315L11.9986 17.0401L15.8779 19.3406C16.5883 19.7622 17.4576 19.139 17.2706 18.3508L16.2424 14.0155L19.6729 11.1009C20.2992 10.5693 19.9721 9.56109 19.1495 9.49694ZM11.9986 15.3262L8.48396 17.4067L9.41872 13.4839L6.31534 10.8443L10.4096 10.496L11.9986 6.80229L13.5971 10.5051L17.6913 10.8534L14.5879 13.4931L15.5226 17.4159L11.9986 15.3262Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconStarOutline;
